import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, ref, watch } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { capitalize } from "@Shared/@Utils/helpers/text";
import i18n from "@Shared/i18n";
import { cloneDeep, toNumber } from "lodash";
export default defineComponent({
  name: "MortgageAmschedule",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    SimpleButton
  }),
  props: {
    inoudata: {
      type: Object,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const startSum = ref(props.inoudata.startSum || 0);
    const startKind = ref(props.inoudata.startKind || 3);
    const timeSum = ref((props.inoudata.timeSum || 0) + 1);
    const timeKind = ref(props.inoudata.timeKind || 0);
    const revamortizPeriodMths = ref(0);
    const detRecType = {
      headType: "detail",
      printPayments: 0,
      payAdd: 0,
      totalPaid: 0,
      interest: 0,
      principal: 0,
      principalBal: 0
    };
    const baseKindOptions = [{
      label: i18n.t("financial-tools.years"),
      value: 1
    }, {
      label: i18n.t("financial-tools.months"),
      value: 2
    }, {
      label: i18n.t("financial-tools.payments"),
      value: 3
    }];
    function calcExactPays(n, numPay2, kindX, typeX, fullAM) {
      if (kindX == 0) {
        if (typeX == 0) {
          return 0;
        }
        if (typeX == 1) {
          return fullAM;
        }
      } else if (kindX == 1) {
        return Math.floor(n * numPay2);
      } else if (kindX == 2) {
        return Math.floor(n * (numPay2 / 12));
      } else if (kindX == 3) {
        return n;
      }
      return 0;
    }
    function formatMoney(val) {
      return formatMoneyValueLong(val);
    }
    function formatRate(val) {
      return val && val > 0 ? this.$options.filters.parsePercentageDecimal(val) : "-";
    }
    function roundPen(val, decs) {
      const fact = 10 ** decs;
      return val > 0 ? Math.round(val * fact) / fact : 0;
    }
    function roundReg(n) {
      return roundPen(n, 2);
    }
    function computeAMLines(fullYear) {
      let payment = toNumber(props.inoudata.PandI);
      const intFact = props.inoudata.intFact;
      const numPay2 = props.inoudata.numPay2;
      const baseRevAm = props.inoudata.baseRevAm;
      const lumpAmt = toNumber(props.inoudata.lumpAmt || 0);
      const lumpYears = toNumber(props.inoudata.lumpYears || 1);
      const incpayValue = toNumber(props.inoudata.incpayValue || 0);
      const incpayTypePerc = props.inoudata.incpayType == "%";
      const incpayValueFact = incpayTypePerc ? 1.0 + incpayValue / 100 : 999;
      const incYears = toNumber(props.inoudata.incYears || 1);
      timeSum.value = calcExactPays(timeSum.value, numPay2, timeKind.value, 1, baseRevAm);
      startSum.value = calcExactPays(startSum.value, numPay2, startKind.value, 0, 0);
      revamortizPeriodMths.value = Math.round(baseRevAm / numPay2 * 12);
      let principalBal = toNumber(props.inoudata.mortgageAmount);
      let annualCount = 1;
      let aYear = false;
      let checkLump;
      let interestPayment;
      let principalPayment;
      let checkBal;
      const freqPayPerYearInt = Math.floor(numPay2);
      let payAdd;
      let totInterest = 0;
      let totPaid = 0;
      let yearInterest = 0;
      let yearPrincipal = 0;
      let detRec;
      for (payAdd = 1; payAdd <= startSum.value; payAdd++) {
        checkLump = 0;
        if ((payAdd - 1) / Math.floor(numPay2) == annualCount - 1) {
          aYear = true;
        }
        if (aYear && incYears >= annualCount) {
          payment = incpayTypePerc ? incpayValueFact * payment : payment + incpayValue;
          payment = roundReg(payment);
        }
        interestPayment = roundReg(principalBal * intFact);
        principalPayment = roundReg(payment - interestPayment);
        checkBal = Math.min(principalBal, principalPayment);
        principalBal = roundReg(principalBal - checkBal);
        if (aYear && lumpYears >= annualCount) {
          checkLump = Math.min(lumpAmt, principalBal);
          principalBal = roundReg(principalBal - checkLump);
        }
        if (aYear) {
          annualCount++;
          aYear = false;
        }
      }
      var printPayments = Math.ceil((startSum.value + 1) / numPay2);
      var printYear = printPayments * numPay2;
      const detRecs = [];
      for (payAdd = startSum.value + 1; payAdd <= timeSum.value && principalBal > 0; payAdd++) {
        checkLump = 0;
        if ((payAdd - 1) / freqPayPerYearInt == annualCount - 1) {
          aYear = true;
        }
        if (aYear && incYears >= annualCount) {
          payment = incpayTypePerc ? incpayValueFact * payment : payment + incpayValue;
          payment = roundReg(payment);
        }
        interestPayment = roundReg(principalBal * intFact);
        principalPayment = roundReg(payment - interestPayment);
        checkBal = Math.min(principalBal, principalPayment);
        principalBal = roundReg(principalBal - checkBal);
        if (aYear && lumpYears >= annualCount) {
          checkLump = Math.min(lumpAmt, principalBal);
          principalBal = roundReg(principalBal - checkLump);
        }
        if (aYear) {
          annualCount++;
          aYear = false;
        }
        if (payAdd <= startSum.value) continue;
        if (principalBal < (interestPayment + principalPayment) / 2) {
          checkBal += principalBal;
          principalBal = 0;
        }
        totInterest = roundReg(totInterest + interestPayment);
        totPaid = roundReg(totPaid + interestPayment + checkBal + checkLump);
        yearInterest += interestPayment;
        yearPrincipal += checkBal + checkLump;
        if (printPayments == fullYear || fullYear == -1) {
          detRec = cloneDeep(detRecType);
          detRec.headType = "detail";
          detRec.payAdd = payAdd;
          detRec.totalPaid = roundReg(interestPayment + checkBal + checkLump);
          detRec.interest = roundReg(interestPayment);
          detRec.principal = roundReg(checkBal + checkLump);
          detRec.principalBal = roundReg(principalBal);
          detRecs.push(detRec);
        }
        if (payAdd != Math.floor(printYear)) continue;
        detRec = cloneDeep(detRecType);
        detRec.headType = "yearTotal";
        detRec.payAdd = printPayments;
        detRec.totalPaid = roundReg(yearInterest + yearPrincipal);
        detRec.interest = roundReg(yearInterest);
        detRec.principal = roundReg(yearPrincipal);
        detRec.principalBal = roundReg(principalBal);
        detRecs.push(detRec);
        printPayments++;
        printYear += numPay2;
        yearInterest = 0;
        yearPrincipal = 0;
      }
      if (yearPrincipal > 0) {
        detRec = cloneDeep(detRecType);
        detRec.headType = "yearTotal";
        detRec.payAdd = printPayments;
        detRec.totalPaid = roundReg(yearInterest + yearPrincipal);
        detRec.interest = roundReg(yearInterest);
        detRec.principal = roundReg(yearPrincipal);
        detRec.principalBal = roundReg(principalBal);
        detRecs.push(detRec);
      }
      detRec = cloneDeep(detRecType);
      detRec.headType = "Total";
      detRec.totalPaid = roundReg(totPaid);
      detRec.interest = roundReg(totInterest);
      detRec.principal = roundReg(totPaid - totInterest);
      detRec.principalBal = -1;
      detRecs.push(detRec);
      emit("generated", detRecs);
      return detRecs;
    }
    let detailRecords = ref([]);
    watch(() => props.inoudata.showAMsched, newVal => {
      if (newVal) detailRecords.value = computeAMLines(-1);
    });
    return {
      timeSum,
      timeKind,
      startSum,
      startKind,
      revamortizPeriodMths,
      baseKindOptions,
      formatMoney,
      formatRate,
      capitalize,
      detailRecords,
      computeAMLines
    };
  }
});